import { render } from "./OrderDetails.vue?vue&type=template&id=3ba9cc75&scoped=true"
const script = {}

import "./OrderDetails.vue?vue&type=style&index=0&id=3ba9cc75&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba9cc75"]])

export default __exports__